const INITIAL_STATE = {
    user: null,
    loading: false,
    loaded: false,

};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case "CLEAR_USER": 
            return {...state, ...INITIAL_STATE } ;
        case "FETCH_USER":
            return { ...state, loading: true, loaded: false, error: null};
        case "FETCH_USER_SUCCESS":
            return { ...state, user: action.payload, loading: false, loaded: true };
        case "FETCH_USER_FAILURE":
            return {user: {}, loading: false, loaded: false };
        case "NEW_USER":
            return {...state, user: {
                accessList : [],
                deleteable : false,
                displayName : "",
                enabled : true,
                language : "",
                password : null,
                username : ""
            }, loaded: true}
        case "PERSIST_USER":
            return { ...state, user: action.payload};
        case "PERSIST_USER_SUCCESS":
            return { ...state, user: null, loading: false };
        case "PERSIST_USER_FAILURE":
            return { ...state, loading: false, loaded: true };
        case "CREATE_USER":
            return { ...state, user: action.payload, loaded: true, loading: false};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/user.js